// extracted by mini-css-extract-plugin
module.exports =  {"title":"_32bbee5fda--title--yNMf1"};